import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=e721bd8e&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=e721bd8e&prod&lang=css"
import style1 from "./Pedidos.vue?vue&type=style&index=1&id=e721bd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e721bd8e",
  null
  
)

export default component.exports